import { BankOutlined, BookOutlined, FileTextOutlined, HomeOutlined, LogoutOutlined, UserOutlined } from "@ant-design/icons";
import { LOGGED_USER } from "../../variables/constants";


export const styles = {
  navbar: {
    position: "sticky",
    top: 0,
    zIndex: 999,
    background: "rgba(255, 255, 255, 0.85)",
    backdropFilter: "blur(12px)",
    borderBottom: "1px solid rgba(36, 33, 102, 0.1)",
    padding: "12px 32px",
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    boxShadow: "0 2px 8px rgba(0, 0, 0, 0.04)",
  },
  searchTrigger: {
    display: "flex",
    alignItems: "center",
    gap: "12px",
    padding: "8px 16px",
    background: "rgba(36, 33, 102, 0.05)",
    border: "1px solid rgba(36, 33, 102, 0.1)",
    borderRadius: "24px",
    cursor: "pointer",
    transition: "all 0.3s ease",
    minWidth: "280px",
  },
  searchModal: {
    position: "fixed",
    top: "15%",
    left: "50%",
    transform: "translateX(-50%)",
    width: "90%",
    maxWidth: "640px",
    background: "rgba(255, 255, 255, 0.95)",
    backdropFilter: "blur(24px)",
    borderRadius: "16px",
    boxShadow: "0 24px 48px rgba(0, 0, 0, 0.15), 0 0 0 1px rgba(36, 33, 102, 0.1)",
    zIndex: 10000,
    overflow: "hidden",
  },
  searchHeader: {
    display: "flex",
    alignItems: "center",
    gap: "12px",
    padding: "16px 20px",
    borderBottom: "1px solid rgba(36, 33, 102, 0.1)",
    cursor: "move",
    background: "rgba(36, 33, 102, 0.03)",
  },
  searchInput: {
    border: "none",
    outline: "none",
    background: "transparent",
    fontSize: "16px",
    flex: 1,
    color: "#242166",
  },
  resultsContainer: {
    maxHeight: "420px",
    overflowY: "auto",
    padding: "8px",
  },
  resultItem: {
    padding: "12px 16px",
    borderRadius: "8px",
    cursor: "pointer",
    transition: "all 0.2s ease",
    display: "flex",
    alignItems: "center",
    gap: "12px",
    marginBottom: "4px",
  },
  categoryTitle: {
    fontSize: "11px",
    fontWeight: "600",
    textTransform: "uppercase",
    color: "#242166",
    opacity: 0.6,
    padding: "12px 16px 4px",
    letterSpacing: "0.5px",
  },
  kbd: {
    padding: "2px 6px",
    background: "rgba(36, 33, 102, 0.08)",
    border: "1px solid rgba(36, 33, 102, 0.15)",
    borderRadius: "4px",
    fontSize: "12px",
    fontFamily: "monospace",
    color: "#242166",
  },
  overlay: {
    position: "fixed",
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    background: "rgba(0, 0, 0, 0.4)",
    backdropFilter: "blur(4px)",
    zIndex: 9999,
  },
  iconButton: {
    width: "40px",
    height: "40px",
    borderRadius: "50%",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    cursor: "pointer",
    transition: "all 0.3s ease",
    background: "transparent",
    border: "none",
  },
  resultsContainerCard: {
    padding: "12px 20px",
    borderTop: "1px solid rgba(36, 33, 102, 0.1)",
    background: "rgba(36, 33, 102, 0.02)",
    fontSize: "12px",
    color: "rgba(36, 33, 102, 0.6)",
    display: "flex",
    gap: "16px",
  },
};

export const inlineStyles = {
  sidebar: (collapsed, bg) => ({
    height: "100vh",
    position: "fixed",
    left: 0,
    top: 0,
    bottom: 0,
    background: bg,
    width: collapsed ? "80px" : "260px",
    transition: "all 0.3s cubic-bezier(0.4, 0, 0.2, 1)",
    boxShadow: "4px 0 24px rgba(36, 33, 102, 0.15)",
    zIndex: 1000,
    overflowX: "visible",
    overflowY: "auto",
    display: "flex",
    flexDirection: "column",
  }),
  header: (collapsed) => ({
    height: "72px",
    display: "flex",
    alignItems: "center",
    justifyContent: collapsed ? "center" : "space-between",
    padding: collapsed ? "0" : "0 20px",
    background: "rgba(255, 255, 255, 0.05)",
    borderBottom: "1px solid rgba(255, 255, 255, 0.08)",
    position: "relative",
  }),
  logo: {
    height: "45px",
    width: "auto",
    objectFit: "contain",
  },
  toggleButton: {
    background: "rgba(255, 255, 255, 0.1)",
    border: "1px solid rgba(255, 255, 255, 0.15)",
    borderRadius: "8px",
    width: "36px",
    height: "36px",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    cursor: "pointer",
    transition: "all 0.3s ease",
    color: "#ffffff",
  },
  menuContainer: {
    flex: 1,
    overflowY: "auto",
    overflowX: "auto",
    padding: "16px 8px",
    scrollbarWidth: "thin",
    scrollbarColor: "rgba(255, 255, 255, 0.2) transparent",
  },
  sectionHeader: (collapsed) => ({
    color: "#8b88d8",
    fontSize: "11px",
    fontWeight: "600",
    textTransform: "uppercase",
    letterSpacing: "1.2px",
    padding: collapsed ? "16px 0 8px" : "16px 20px 8px",
    marginTop: "8px",
    opacity: collapsed ? 0 : 1,
    transition: "opacity 0.3s ease",
    borderTop: "1px solid rgba(255, 255, 255, 0.06)",
  }),
  menuStyle: {
    background: "transparent",
    border: "none",
    color: "#ffffff",
  },
  menuItemStyle: {
    margin: "4px 0",
    borderRadius: "10px",
    height: "44px",
    lineHeight: "44px",
    transition: "all 0.3s ease",
  },
  submenuTitleStyle: {
    borderRadius: "10px",
    margin: "4px 0",
  },
};

export const userMenuItems = (navigate, changeCompanyFunction, logout) => [
  {
    key: "profile",
    icon: <UserOutlined />,
    label: "Mon profil",
    onClick: () => navigate("/mon-profil"),
  },
  LOGGED_USER?.agence?.typeAgence === "SIEGE" && {
    key: "company",
    icon: <BankOutlined />,
    label: LOGGED_USER.profil.organisme.raisonSociale,
    onClick: () => navigate("/ma-compagnie"),
  },
  LOGGED_USER?.agence && {
    key: "agency",
    icon: <HomeOutlined />,
    label: LOGGED_USER?.agence?.nom,
    onClick: () => navigate("/mon-agence"),
  },
  { type: "divider" },
  LOGGED_USER?.agence?.typeAgence === "COURTIER" && {
    key: "change-company",
    icon: <BankOutlined />,
    label: "Changer de compagnie",
    onClick: () => changeCompanyFunction(),
  },
  { type: "divider" },
  { key: "documentation", icon: <BookOutlined />, label: "Documentation", onClick: () => navigate("/video-tutorials") },
  // LOGGED_USER?.profil?.nom?.toLowerCase().includes("admin") && { key: "logs", icon: <FileTextOutlined />, label: "Logs", onClick: () => navigate("/logs-users") },
  { type: "divider" },
  {
    key: "logout",
    icon: <LogoutOutlined />,
    label: "Déconnexion",
    onClick: () => logout(),
  },
].filter(Boolean);
